// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1EaNI","resourcesContainer":"styles_resourcesContainer__hH8wx"};